import React from "react";
import MaterialTable, { MTableToolbar } from "@material-table/core";
// eslint-disable-next-line no-unused-vars
import { Button, Modal as ModalAntd } from "antd";
import { ExportPdf } from "@material-table/exporters";
import { ExportCsv } from "@material-table/exporters";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { esES } from "@mui/material/locale";

import {
  PlusOutlined,
  FilterOutlined,
  EditOutlined,
  DeleteOutlined,
  MailOutlined,
  FileDoneOutlined,
  WhatsAppOutlined,
  PhoneOutlined,
  CloseCircleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
// import MaterialTableLocalization from "../../localization/materialTable.localization";
// import LinkOffIcon from "@mui/icons-material/LinkOff";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import "./GenericList.css";
import { DownloadOutlined } from "@mui/icons-material";
import FileOpenOutlinedIcon from "@mui/icons-material/FileOpenOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import { useTheme as useAppTheme } from "../../context/ThemeContext";

// const { confirm } = ModalAntd;

export default function GenericList(props) {
  const {
    columns,
    data,
    actions,
    pageSize,
    title,
    onEditAction,
    onCreateButtonClick,
    onDeleteAction,
    onCancelAction,
    onDownloadAction,
    addDesactivated,
    onView,
    onSendByEmail,
    onSeeDetail,
    onOpenDocuments,

    onPay,
  } = props;

  const { themeMode } = useAppTheme();
  const isDarkMode = themeMode === "dark";

  const theme = React.useMemo(
    () =>
      createTheme(
        {
          palette: {
            mode: isDarkMode ? "dark" : "light",
            primary: { main: "#E16726" },
            background: {
              default: isDarkMode ? "#0a0c0f" : "#f4f5f7",
              paper: isDarkMode ? "#13151a" : "#ffffff",
            },
            text: {
              primary: isDarkMode ? "#f3f4f6" : "#1a1d23",
              secondary: isDarkMode ? "#9ca3af" : "#6b7280",
            },
          },
          typography: {
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            fontSize: 13,
          },
          components: {
            MuiTableCell: {
              styleOverrides: {
                head: {
                  backgroundColor: isDarkMode ? "#161820" : "#fafafa",
                  fontWeight: 700,
                  color: isDarkMode ? "#f3f4f6" : "#1a1d23",
                  borderBottom: `1px solid ${isDarkMode ? "#2a2d36" : "#e8eaed"}`,
                },
                root: {
                  borderColor: isDarkMode ? "#2a2d36" : "#e8eaed",
                  color: isDarkMode ? "#f3f4f6" : "#1a1d23",
                },
              },
            },
            MuiPaper: {
              styleOverrides: {
                root: {
                  backgroundImage: "none",
                  boxShadow: "none !important",
                  borderRadius: "0px !important",
                  border: "none !important",
                },
              },
            },
          },
        },
        esES
      ),
    [isDarkMode]
  );

  const [filtering, setFiltering] = React.useState(false);

  const actionsList = {
    edit: {
      icon: EditOutlined,
      tooltip: "Edit",
      onClick: (event, rowData) => onEditAction(rowData._id),
    },
    email: {
      icon: MailOutlined,
      tooltip: "Email",
      onClick: (event, rowData) => sendEmailAction(rowData.email || ""),
    },
    whatsApp: {
      icon: WhatsAppOutlined,
      tooltip: "contact by WhatsApp",
      onClick: (event, rowData) => sendWhatsappAction(rowData.cellPhone || ""),
    },
    phoneCall: {
      icon: PhoneOutlined,
      tooltip: "contact by phone",
      onClick: (event, rowData) => callByPhoneAction(rowData.phone || ""),
    },
    newTask: {
      icon: FileDoneOutlined,
      tooltip: "Add task",
    },
    delete: {
      icon: DeleteOutlined,
      tooltip: "Delete",
      onClick: (event, rowData) => onDeleteAction(rowData._id),
    },
    cancel: {
      icon: CloseCircleOutlined,
      tooltip: "Cancel",
      onClick: (event, rowData) => onCancelAction(rowData._id),
    },
    download: {
      icon: DownloadOutlined,
      tooltip: "Download",
      onClick: (event, rowData) => onDownloadAction(rowData),
    },
    pay: {
      icon: PaidOutlinedIcon,
      tooltip: "Pay",
      onClick: (event, rowData) => onPay(rowData),
      hidden: (event, rowData) => !(rowData?.invoiceStatus?._id === "JCIS"),
    },

    view: {
      icon: EyeOutlined,
      tooltip: "View detail",
      onClick: (event, rowData) => onView(rowData),
    },
    openDocument: {
      icon: FileOpenOutlinedIcon,
      tooltip: "Open Documents",
      onClick: (event, rowData) => onOpenDocuments(rowData),
    },
    // approveOpportunity: {
    //   icon: TaskAltOutlinedIcon,
    //   tooltip: "Approve Proposal",
    //   onClick: (event, rowData) => onApproveOpportunity(rowData),
    //   hidden: (event, rowData) =>
    //     rowData.approvedByCustomer === true ||
    //     rowData.status._id !== "PROPOSAL" ||
    //     rowData.amount <= 0,
    // },

    sendByEmail: {
      icon: ForwardToInboxIcon,
      tooltip: "Send by email",
      onClick: (event, rowData) => onSendByEmail(rowData),
    },
    seeDetail: {
      icon: EyeOutlined,
      tooltip: "See detail",
      onClick: (event, rowData) => onSeeDetail(rowData),
    },
  };

  const actionsSelected = actions.map((action) => {
    return actionsList[action];
  });

  function sendWhatsappAction(cellPhone) {
    if (cellPhone) {
      window.open(`https://wa.me/${cellPhone}`);
    }
  }

  function sendEmailAction(email) {
    const mailto = `mailto:${email}`;
    window.open(mailto);
  }

  function callByPhoneAction(phoneNumber) {
    const call = `tel:${phoneNumber}`;
    window.open(call);
  }

  return (
    <>
      <div className="listContainer">
        <ThemeProvider theme={theme}>
          <MaterialTable
            // localization={MaterialTableLocalization}
            columns={columns}
            className="genericTable"
            data={data}
            title={title}
            components={{
              Toolbar: (props) => (
                <div className="table-toolbar">
                  <div className="table-toolbar__main">
                    <MTableToolbar {...props} />
                  </div>
                  <div className="table-toolbar__actions">
                    <Button
                      className="table-icon-button"
                      onClick={() => {
                        setFiltering((currentFilter) => !currentFilter);
                      }}
                      aria-label="Toggle filters"
                    >
                      <FilterOutlined />
                    </Button>
                    {addDesactivated ? null : (
                      <Button
                        type="primary"
                        className="table-icon-button table-icon-button--primary"
                        onClick={() => {
                          onCreateButtonClick();
                        }}
                        aria-label="Create"
                      >
                        <PlusOutlined />
                      </Button>
                    )}
                  </div>
                </div>
              ),
            }}
            actions={actionsSelected}
            options={{
              actionsColumnIndex: -1,
              pageSize: pageSize || 10,
              filtering,
              exportMenu: [
                {
                  label: "Exportar PDF",
                  exportFunc: (cols, datas) =>
                    ExportPdf(cols, datas, "reporte"),
                },
                {
                  label: "Exportar CSV",
                  exportFunc: (cols, datas) =>
                    ExportCsv(cols, datas, "reporte"),
                },
              ],
            }}
            style={{ width: "100%" }}
          />
        </ThemeProvider>
      </div>
    </>
  );
}
